/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Greek_Philology19Inputs */

const en__field_enum_study_greek_philology19 = /** @type {(inputs: _Field_Enum_Study_Greek_Philology19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Greek Philology`)
};

const de__field_enum_study_greek_philology19 = /** @type {(inputs: _Field_Enum_Study_Greek_Philology19Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Griechische Philologie`)
};

/**
* | output |
* | --- |
* | "Greek Philology" |
*
* @param {_Field_Enum_Study_Greek_Philology19Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_greek_philology19 = /** @type {((inputs?: _Field_Enum_Study_Greek_Philology19Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Greek_Philology19Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_greek_philology19(inputs)
	return de__field_enum_study_greek_philology19(inputs)
});
export { _field_enum_study_greek_philology19 as "_field_enum_STUDY_GREEK_PHILOLOGY" }